export default __webpack_public_path__ + "static/media/Threshold-NotMet.444af362.svg";